module.exports = __webpack_public_path__ + "png/friends-message-angle.png?b868e0c3ff95741ef9032ed0d712794c";